/**
 * Atributos base de todas las entidades del juego
 */
export interface EntityAttributes {
  // Vida y recursos
  hp: number;
  maxHp: number;
  mana: number;
  maxMana: number;
  stamina: number;
  maxStamina: number;
  
  // Necesidades básicas
  hunger: number;
  maxHunger: number;
  thirst: number;
  maxThirst: number;
  
  // Estadísticas de combate
  minDamage: number;
  maxDamage: number;
  physDef: number;
  magicDef: number;
  
  // Estadísticas de movimiento y ataque
  moveSpeed: number;
  attackSpeed: number;

  // Cuánto (ms) permanecen en el piso las huellas direccionales de esta entidad
  // antes de desvanecerse (footsteps sets 1–4). Base = FOOTSTEP_BASE_DURATION_MS;
  // modificable por items/mods. Los footsteps de animación (5–7) lo ignoran.
  footstepDuration: number;
  
  // Estadísticas de crítico y evasión
  critChance: number;
  critMultiplier: number;
  evasion: number;
  castSpeed: number; // Cast speed bonus (0.0 = base, 0.10 = 10% faster)

  // Probabilidad (0.0–1.0) de BLOQUEAR un golpe físico entrante. Un golpe
  // bloqueado mitiga su daño por COMBAT.BLOCK_DAMAGE_REDUCTION antes de la
  // defensa. Se clampea a COMBAT.BLOCK_MAX_CHANCE en el roll. Fuente: escudos,
  // afijos, árbol de espíritu (rama Enano).
  blockChance: number;
  // Reducción (0.0–1.0) del costo de MANÁ de los hechizos. Se clampea a
  // COMBAT.MANA_REDUCTION_MAX al aplicar. Fuente: árbol (rama Gnomo), afijos.
  manaReduction: number;

  // Regeneración
  regenHP: number;
  regenMana: number;
  regenStamina: number;
}

/**
 * Posición en el mapa (coordenadas isométricas)
 */
export interface Position {
  x: number;
  y: number;
  z?: number; // Para capas del mapa
}

/**
 * Dirección de movimiento/animación
 */
export enum Direction {
  UP = 0,
  RIGHT = 1,
  DOWN = 2,
  LEFT = 3,
}

/**
 * Estado de la entidad
 */
export enum EntityState {
  IDLE = 'idle',
  MOVING = 'moving',
  ATTACKING = 'attacking',
  CASTING = 'casting',
  DEAD = 'dead',
  /**
   * Player tiene un panel de interacción con NPC abierto (merchant o spell vendor).
   * Bloquea movimiento, ataques y casts hasta que se cierre el panel.
   * Aplica al PlayerState, NO al NPCState (es el player el que está "ocupado").
   */
  INTERACTING_NPC = 'interacting_npc',
}

